import React, { ReactNode } from "react";

import { Box, SxProps } from "@mui/material";

export interface AuctionCardContainerProps {
  singleRow?: boolean;
  children?: ReactNode;
  sx?: SxProps;
}

const AuctionCardContainer = (props: AuctionCardContainerProps) => {
  const { singleRow = false } = props;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <Box
        sx={{
          display: "block",
          width: "304px",
          "@media screen and (min-width: 672px)": {
            width: "608px"
          },
          "@media screen and (min-width: 976px)": {
            width: "912px"
          },
          "@media screen and (min-width: 1280px)": {
            width: "1216px"
          },
          "@media screen and (min-width: 1584px)": {
            width: "1520px"
          },
          overflow: "hidden",
          mb: 2,
          ...props.sx
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "row",
            flexWrap: singleRow ? "nowrap" : "wrap",
            width: singleRow ? "5000px" : "100%",
            m: 1,
            gap: 2
          }}
        >
          {props.children}
        </Box>
      </Box>
    </Box>
  );
};

export default AuctionCardContainer;
